import { useEffect } from 'react';
import { pathFor } from '../i18n/routes';

export default function useSEO(meta, routeKey, lang) {
  useEffect(() => {
    if (!meta) return;
    document.title = meta.title;
    document.documentElement.lang = lang === 'pt' ? 'pt-PT' : 'en';

    let desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', meta.desc);

    document.querySelectorAll('link[data-hreflang]').forEach((el) => el.remove());
    const origin = window.location.origin;
    ['pt', 'en'].forEach((l) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = l;
      link.href = origin + pathFor(routeKey, l);
      link.setAttribute('data-hreflang', '1');
      document.head.appendChild(link);
    });
    const xdef = document.createElement('link');
    xdef.rel = 'alternate';
    xdef.hreflang = 'x-default';
    xdef.href = origin + pathFor(routeKey, 'pt');
    xdef.setAttribute('data-hreflang', '1');
    document.head.appendChild(xdef);
  }, [meta, routeKey, lang]);
}
